import { defineMessages } from 'react-intl';

export const openParenthesis = defineMessages({
  'dt:parenthesis:open1': {
    id: 'parenthesis.open1.title',
    defaultMessage: '(',
    value: '(',
  },
  'dt:parenthesis:open2': {
    id: 'parenthesis.open2.title',
    defaultMessage: '((',
    value: '((',
  },
  'dt:parenthesis:open3': {
    id: 'parenthesis.open3.title',
    defaultMessage: '(((',
    value: '(((',
  },
});

export const closeParenthesis = defineMessages({
  'dt:parenthesis:close1': {
    id: 'parenthesis.close1.title',
    defaultMessage: ')',
    value: ')',
  },
  'dt:parenthesis:close2': {
    id: 'parenthesis.close2.title',
    defaultMessage: '))',
    value: '))',
  },
  'dt:parenthesis:close3': {
    id: 'parenthesis.close3.title',
    defaultMessage: ')))',
    value: ')))',
  },
});
